import { render, staticRenderFns } from "./DeletePrompt.vue?vue&type=template&id=d65c7036"
import script from "./DeletePrompt.vue?vue&type=script&lang=js"
export * from "./DeletePrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports